import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import modules from './modules'
import API from '@/services/api'
Vue.use(Vuex)

// Persistência do Auth (criptografado)
const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  reducer: ({ auth }) => {
    const encryptedText = API.encrypt(JSON.stringify({ auth }))
    return encryptedText
  },
})

// Persistência de Preferências do Usuário (sem criptografia)
const vuexLocalStoragePreferences = new VuexPersist({
  key: 'userPreferences',
  storage: window.localStorage,
  reducer: (state) => ({
    products: {
      showPriceWithAdd: state.products.showPriceWithAdd,
    },
  }),
})

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin, vuexLocalStoragePreferences.plugin],
  state,
  mutations,
  actions,
  modules,
})
